module.exports = __webpack_public_path__ + "img/1-2-fundacio-mallorca-turisme.0667436c.png";